import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-main-filter',
  templateUrl: './main-filter.component.html',
  imports: [],
  styleUrls: ['./main-filter.component.scss']
})
export class MainFilterComponent implements OnInit {

  public CLASS_ACTIVE_FILTER: string = 'component-main-filter__pill--active';

  @Input() reportCount: number = 0;
  @Output() emitClickedFilter = new EventEmitter();
  @Output() emitReverseSort = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public singleEmitClickedFilter(event: any): boolean | void {
    const element = event.target || event.srcElement || event.currentTarget;

    if (element.classList.contains(this.CLASS_ACTIVE_FILTER + '--reverse')) {
      element.classList.remove(this.CLASS_ACTIVE_FILTER + '--reverse');
      this.emitReverseSort.next(true);
      return false;
    }

    if (element.classList.contains(this.CLASS_ACTIVE_FILTER)) {
      element.classList.add(this.CLASS_ACTIVE_FILTER + '--reverse');
      this.emitReverseSort.next(false);
      return false;
    }

    const current = document.getElementsByClassName(this.CLASS_ACTIVE_FILTER)[0];
    if (current) current.classList.remove(this.CLASS_ACTIVE_FILTER);

    const currentReverse = document.getElementsByClassName(this.CLASS_ACTIVE_FILTER + '--reverse')[0];
    if (currentReverse) currentReverse.classList.remove(this.CLASS_ACTIVE_FILTER + '--reverse');

    element.classList.add(this.CLASS_ACTIVE_FILTER);
    this.emitReverseSort.next(true);
    this.emitClickedFilter.emit(element.getAttribute('data-filter-by'));
  }

  public getCheckboxValue(event: boolean): void {
    if (event) {
      this.emitClickedFilter.emit('report_highlighted');
    } else {
      this.emitClickedFilter.emit('');
    }
  }
}
